import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserInputPlayers = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解5：选手录入
          </Title>
          <div className="text-lg">
            <p>一、手动添加</p>
            <p>1、点击手动新增一队，按提示录入选手信息。</p>
            <div className="my-4">
              <Image src="/manual/input_players/1.png" alt="" />
            </div>
            <p>队号：仅用于标识队伍编号，建议使用系统生成的默认值。人工录入时，系统不会校验队号是否重复。队号重复对系统运行无影响。</p>
            <p>队长：录入姓名，必填，录入时不要有空格。</p>
            <p>队友：录入姓名，选填，录入时不要有空格。如果不填，则表示单人报名，开赛前需要重新组队。</p>
            <p>手机：选填。如果有重名的选手，建议填入手机号，重名的选手签到/记分时，使用手机号登录，以便区分。</p>
            <p>团体：根据需要选填。</p>
            <p>团体是否自填：勾选后，可人工录入团体名称。</p>
            <p>
              注意：此处自填的团体名称，编排时会用于判断本团体是否相遇，不会添加到团体列表中，也不会用于团体排名。需要团体排名时必须先
              在比赛设置→赛事设置的团体列表中添加，然后在此处选择填入，不能自填。
            </p>
            <p>2、新增时，系统会对录入的选手信息进行校验，若录入的 2 名选手姓名和系统中已有队伍的 2 名选手姓名相同，系统会认为是同一队伍进行提示，由编排员决定是否录入。</p>
            <p>二、批量导入</p>
            <p>1、点击批量导入队伍，选择编辑好的选手信息表导入。</p>
            <p>2、点击下载样例表，可下载本赛事的表格样表，用于编辑选手信息。</p>
            <p>
              3、批量导入时，系统会进行检验，如果 1 个队伍中 2 名选手的姓名及手机号，和别的队伍中 2
              名选手的姓名及手机号完全相同（若均未填写手机号，则默认手机号相同），则会认为队伍重复并自动过滤掉，确需录入的，由编排员人工录入。
            </p>
            <p>三、操作菜单功能</p>
            <p>点击操作，出现菜单列表：</p>
            <div className="my-4">
              <Image src="/manual/input_players/2.png" alt="" />
            </div>
            <p>新建队伍：同手动新增一队。</p>
            <p>导出队伍信息：以 Excel表格形式导出录入的队伍信息。</p>
            <p>导出样例表：同下载样例表。</p>
            <p>批量导入：同批量导入队伍。</p>
            <p>批量删除：删除所有队伍信息。</p>
            <p>
              付费群发短信：点击下面的群发短信，在短信模板中完善信息后，点击立即发送，会提示“本次将发送 1 条短信，每条短信收费 2
              角，一旦确认无法撤销”，点击确认发送，会出现付款二维码，用微信扫码支付后（短信数量按照录入的手机号数量计算），系统自动向选手发送比赛信息。
            </p>
            <div className="my-4">
              <Image src="/manual/input_players/3.png" alt="" />
            </div>
            <p>四、样例表</p>
            <p>注意录入时不要有空格，尤其是姓名，系统会把空格也当成一个字处理。如果姓名中带了空格，选手用手机输入姓名登录时就必须有空格。</p>
            <p>1、单人赛、团团转。</p>
            <div className="my-4">
              <Image src="/manual/input_players/4.png" alt="" />
            </div>
            <p>姓名：必填。</p>
            <p>手机：选填。</p>
            <p>2、组队赛、循环赛、超分赛、米切尔复式赛、瑞士偏差分复式赛、联赛、团体赛。</p>
            <div className="my-4">
              <Image src="/manual/input_players/5.png" alt="" />
            </div>
            <p>队名：仅为标记（可不填），导入系统时会自动编号。</p>
            <p>队员 1、队员 2：必填。</p>
            <p>手机号：选填。</p>
            <p>团体名：根据实际需要决定，团体赛时必须填。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserInputPlayers as any, {
  title: '录入选手与队伍 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统选手录入:手动新增队伍、Excel 批量导入、队长队友与手机号填写规范、单人报名与开赛前组队。',
})

export default UserInputPlayers
